define(function (require) {
	"use strict";

	var LE = require("app");
	var Template = require("personalization-web-agent-templates/csat.tmpl");
	var Button = require("ui/button/Button");
	var BaseAnchorView = require("personalization-views/BaseAnchorView");
	var positionsUtility = require("personalization-utils/positionsUtility");

	var CsatView = {};
	LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
		CsatView = BaseAnchorView.extend({
			template: Template,
			withUIComponents: true,
			className: "csat-container anchor hide",
			ui: {
				csatEditButton: ".csat-edit-button",
				currentCsatStatus: ".current-status-container"
			},
			uiComponents: {
				editButton: {
					type: Button,
					options: {
						el: "view.ui.csatEditButton",
						permutation: Button.PERMUTATION.BTN_PRIMARY
					},
					events: {
						"click": "_onEditButtonClick"
					}
				}
			},

			initialize: function (options) {
				LEPersonalization.logger.info("initializing", "CsatView:initialize. options = " + options);
				this.anchorSelector = options.anchorSelector;
				this.featureId = options.featureId;
				BaseAnchorView.prototype.initialize.call(this, options);
			},
			onRender: function (options) {
				LEPersonalization.logger.info("rendering", "CsatView:onRender. options = " + options);
				var offset = positionsUtility.getOffset(this.anchorSelector, positionsUtility.POSITION_X.RIGHT, positionsUtility.POSITION_Y.TOP);
				if (offset) {
					this.$el.css(offset);
				}
			},
			onClose: function () {
				LEPersonalization.logger.debug("closing view", "CsatView:onClose.");
			},
			setCsatValue: function (options) {
				LEPersonalization.logger.debug("sets retrieved CSAT value", "CsatView:setCsatValue. options = " + options);
                var siteSettingsModel = options.siteSettingsModel;
                var csatSetting = siteSettingsModel.getValue();
				if (csatSetting === "true") {
					this.ui.currentCsatStatus.text(LE.translator.translate("LEPersonalization.webAgent.CSAT.visible.label"));
				} else {
					this.ui.currentCsatStatus.text(LE.translator.translate("LEPersonalization.webAgent.CSAT.hidden.label"));
				}
                this.$el.removeClass("hide");
			},
			_onEditButtonClick: function () {
				LEPersonalization.logger.debug("Edit button was clicked", "CsatView:_onEditButtonClick.");
				this.trigger("csat:navigateToFeatureEdit");
			}
		});
	});

	return CsatView;
});
